import { graphql } from '@/gql';
import type { RefundDeliveryOrderMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const refundDeliveryOrder = async ({
  deliveryOrderId,
  refundCredits,
  refundCost,
  refundCostAsCredits,
  notes,
}: RefundDeliveryOrderMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      deliveryOrderId,
      refundCredits,
      refundCost,
      refundCostAsCredits,
      notes,
    },
    mutation: graphql(`
      mutation RefundDeliveryOrder(
        $deliveryOrderId: String!
        $refundCredits: Float
        $refundCost: Float
        $refundCostAsCredits: Boolean
        $notes: String!
      ) {
        refundDeliveryOrder(
          deliveryOrderId: $deliveryOrderId
          refundCredits: $refundCredits
          refundCost: $refundCost
          refundCostAsCredits: $refundCostAsCredits
          notes: $notes
        ) {
          id
        }
      }
    `),
  });

  return response.data?.refundDeliveryOrder;
};
